import { useEffect, useState } from 'react';

/**
 * Returns the new entity name based on the hostname.
 * - 'AOE Hungary Kft' for finnolab.hu
 * - 'AOE Austria GmbH' for all other domains
 */
export const useNewEntityName = () => {
  const [newEntityName, setNewEntityName] = useState('AOE Austria GmbH');
  const [oldEntityName, setOldEntityName] = useState('Finnoconsult');

  useEffect(() => {
    const isFinnoLab = window.location.hostname.includes('finnolab.hu');
    setNewEntityName(isFinnoLab ? 'AOE Hungary Kft' : 'AOE Austria GmbH');
    setOldEntityName(isFinnoLab ? 'FinnoLab' : 'FinnoConsult');
  }, []);

  return { newEntityName, oldEntityName };
};
